import { nightsOnOffer } from "@quote/quote/api/init_quote/utils";
import { addDays, eachDayOfInterval, max } from "date-fns";
import { StateCreator } from "zustand";

import { ordinalShortMonthDay } from "@/utils/helpers";

import { ArrivalState } from "./types";

const initState = {
  dateParam: null,
  arrivalDate: null,
  departureDate: null,
  onRequest: false,
  ppPrice: 0,
  onlyForEnquiry: false,
  isEnquiry: false,
};

export const createDateState: StateCreator<
  ArrivalState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,
  arrivalActions: {
    setDateAndPrice: (
      arrivalDate: Date,
      departureDate: Date,
      ppPrice: number,
    ) => {
      set(
        { arrivalDate, departureDate, ppPrice },
        undefined,
        "date/setDateAndPrice",
      );
    },

    resetDateAndPrice: () => {
      set(
        {
          arrivalDate: initState.arrivalDate,
          departureDate: initState.departureDate,
          ppPrice: initState.ppPrice,
        },
        undefined,
        "date/resetDateAndPrice",
      );
    },

    setOnRequest: (onRequest: boolean) => {
      set({ onRequest }, undefined, "date/setOnRequest");
    },

    setOnlyForEnquiry: (onlyForEnquiry: boolean) => {
      set({ onlyForEnquiry }, undefined, "date/setOnlyForEnquiry");
    },

    setIsEnquiry: (isEnquiry: boolean) => {
      set({ isEnquiry }, undefined, "date/setIsEnquiry");
    },

    resetState: () => set(initState),
  },
  arrivalUtils: {
    travelDates: (nights, arrivalDate = get().arrivalDate) =>
      arrivalDate && nights
        ? eachDayOfInterval({
            start: arrivalDate,
            end: addDays(arrivalDate, nights),
          })
        : [],

    generateSummaryText: () => {
      const { arrivalDate, departureDate } = get();

      if (arrivalDate && departureDate) {
        return `${ordinalShortMonthDay(arrivalDate)} - ${ordinalShortMonthDay(departureDate)}`;
      }

      return "";
    },

    getDepartureDate: (arrivalDate, offer) => {
      const { travelDates } = get().arrivalUtils;
      const totalNights = nightsOnOffer(offer);
      const selectedDates = travelDates(totalNights, new Date(arrivalDate));
      return max(selectedDates);
    },

    getArrivalDate: () => get().arrivalDate,
  },
});
